import React from "react";
import { Lock, FileSpreadsheet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ExcelExportModal = ({
  excelModalOpen,
  setExcelModalOpen,
  excelPassword,
  setExcelPassword,
  handleExportExcel,
  exportingExcel
}) => {
  if (!excelModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
            <Lock className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <h3 className="font-semibold text-slate-900">Exportar Excel</h3>
            <p className="text-sm text-slate-500">Ingresa la clave para descargar</p>
          </div>
        </div>
        
        <div className="space-y-4">
          <div>
            <Label htmlFor="excel-password" className="text-sm">Clave de exportación</Label>
            <Input
              id="excel-password"
              type="password"
              value={excelPassword}
              onChange={(e) => setExcelPassword(e.target.value)}
              placeholder="Ingresa la clave"
              className="mt-1"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleExportExcel();
                }
              }}
              data-testid="excel-password-input"
            />
          </div>
          
          <div className="flex gap-2 justify-end">
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                setExcelModalOpen(false);
                setExcelPassword("");
              }}
            >
              Cancelar
            </Button>
            <Button
              size="sm"
              onClick={handleExportExcel}
              disabled={exportingExcel || !excelPassword}
              className="bg-green-600 hover:bg-green-700"
              data-testid="excel-export-confirm-btn"
            >
              {exportingExcel ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
                  Exportando...
                </>
              ) : (
                <>
                  <FileSpreadsheet className="w-4 h-4 mr-2" />
                  Descargar
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
